import Vue from 'vue'

import KBreadcrumbs from './KBreadcrumbs.vue'
Vue.component('k-breadcrumbs', KBreadcrumbs)

import KSearchBar from './KSearchBar.vue'
Vue.component('k-search-bar', KSearchBar)

import KButton from './KButton.vue'
Vue.component('k-btn', KButton)

import KTextField from './KTextField.vue'
Vue.component('k-text-field', KTextField)

import KChip from './KChip.vue'
Vue.component('k-chip', KChip)

import KCheckbox from './KCheckbox.vue'
Vue.component('k-checkbox', KCheckbox)

import KProgressLinear from './KProgressLinear.vue'
Vue.component('k-progress-linear', KProgressLinear)

import KProgressCircular from './KProgressCircular.vue'
Vue.component('k-progress-circular', KProgressCircular)

import KMenu from './KMenu.vue'
Vue.component('k-menu', KMenu)

import KEditDialog from './KEditDialog.vue'
Vue.component('k-edit-dialog', KEditDialog)

import KIcon from './KIcon.vue'
Vue.component('k-icon', KIcon)

import KTabs from './KTabs.vue'
Vue.component('k-tabs', KTabs)

import KTab from './KTab.vue'
Vue.component('k-tab', KTab)

import KPanel from './KPanel.vue'
Vue.component('k-panel', KPanel)

import KAutocomplete from './KAutocomplete.vue'
Vue.component('k-autocomplete', KAutocomplete)

import KDataTable from './KDataTable.vue'
Vue.component('k-data-table', KDataTable)

import KDivider from './KDivider.vue'
Vue.component('k-divider', KDivider)

import KNavigationDrawer from './KNavigationDrawer.vue'
Vue.component('k-navigation-drawer', KNavigationDrawer)

import KDialog from './KDialog.vue'
Vue.component('k-dialog', KDialog)

import KDatePicker from './KDatePicker.vue'
Vue.component('k-date-picker', KDatePicker)

import KTree from './KTree/KTree.vue'
Vue.component('k-tree', KTree)

import KList from './KList.vue'
Vue.component('k-list', KList)

import KEditorForm from './KEditorForm.vue'
Vue.component('k-editor-form', KEditorForm)

import KBadge from './KBadge.vue'
Vue.component('k-badge', KBadge)

import KLayout from './KLayout.vue'
Vue.component('k-layout', KLayout)

import KFlex from './KFlex.vue'
Vue.component('k-flex', KFlex)

import KResponsive from './KResponsive.vue'
Vue.component('k-responsive', KResponsive)

import KSlider from './KSlider.vue'
Vue.component('k-slider', KSlider)

import KSparkline from './KSparkline.vue'
Vue.component('k-sparkline', KSparkline)

import KVideoPlayer from './KVideoPlayer.vue'
Vue.component('k-video-player', KVideoPlayer)

import KVideoGrid from './KVideoGrid.vue'
Vue.component('k-video-grid', KVideoGrid)

import KVideoArea from './KVideoArea.vue'
Vue.component('k-video-area', KVideoArea)

import KKeyValue from './KKeyValue.vue'
Vue.component('k-key-value', KKeyValue)

import KLabelColorPicker from './KLabelColorPicker.vue'
Vue.component('k-label-color-picker', KLabelColorPicker)

